const BannerPresets = {
  adNumber: "",
  advertiser: "",
  advertiserId: "",
  bannerTitle: "",
  bannerType: "hybrid",
  bannerURL: "",
  bespokeTemplate: false,
  currentUser: false,
  key: "",
  lastModAt: "",
  lastModBy: "",
  templateId: "12418517",
  templateType: "hybrid",
  userId: "",
  fields: {
    IncludeValueTile: false,
    AddClubcardPrice: false,
    AddRegularPrice: false,
    RegularPrice: "",
    ShowPackshots: false,
    ValueTileTop: "",
    ValueTileTopFontSize: "",
    ValueTileBottom: "",
    ValueTileBottomFontSize: "",
    AddLogo: false,
    LogoPosition: "left",
    LogoDescription: "",
    MainPackshotDescription: "",
    AddSecondPackshot: false,
    MainBackgroundPosition: "right",
    MainBackgroundVertical: "top",
    MainBackgroundSize: "cover",
    MainBackgroundColour: "",
    CTAColour: "0, 83, 159",
    CTAArrowColour: "FFFFFF",
    MainTextDescription: "",
    Drinkaware: false,
    DrinkawareType: "white",
    TextPosition: "right",
    ExtraBackgroundPositionFromLeft: "",
    ExtraBackgroundPositionFromTop: "",
    ExtraBackgroundSize: "",
    Logo: {
      path: "",
    },
    DesktopText: {
      path: "",
    },
    TabletText: {
      path: "",
    },
    MainPackshot: {
      path: "",
    },
    SecondPackshot: {
      path: "",
    },
    MainBackgroundImage: {
      path: "",
    },
    ExtraBackgroundImage: {
      path: "",
    },
  },
};

export default BannerPresets;
